import { createReducer } from '@api/createRequestStore';
import { COMPARE_SHARING_SCOPE } from './types';

export default createReducer(COMPARE_SHARING_SCOPE);
